import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { DesignPartnerFooter } from "./DesignPartnerFooter";
import { DesignPartnerNav } from "./DesignPartnerNav";
import "./design-partner.css";
import {
  readDesignPartnerTheme,
  toggleDesignPartnerTheme,
  writeDesignPartnerTheme,
  type DesignPartnerTheme,
} from "./theme";

export function DesignPartnerLayout() {
  const location = useLocation();
  const [theme, setTheme] = useState<DesignPartnerTheme>(() => readDesignPartnerTheme());

  useEffect(() => {
    writeDesignPartnerTheme(theme);
  }, [theme]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const onToggleTheme = () => {
    setTheme((t) => toggleDesignPartnerTheme(t));
  };

  return (
    <div className="dp-site" data-theme={theme} data-testid="dp-site">
      <a className="skip" href="#main">
        Skip to content
      </a>
      <DesignPartnerNav theme={theme} onToggleTheme={onToggleTheme} />
      <main id="main">
        <Outlet />
      </main>
      <DesignPartnerFooter />
    </div>
  );
}
